export const formatDate = (_d: Date) => {
  return `${_d.getFullYear()}-${_d.getMonth() + 1}-${_d.getDate()}`
}
